var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.game)?_c('ReceivedGiftCodesPanel',{attrs:{"id-game":_vm.game.id}}):_c('NotFoundPanel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }